import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

/**
 * Reusable Result Display Component
 * Shows success/error state with formatted data
 */
const ResultCard = ({ result, type }) => {
  if (!result) return null;

  const isSuccess = result.success;
  const bgColor = isSuccess ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200';
  const textColor = isSuccess ? 'text-green-700' : 'text-red-700';
  const IconComponent = isSuccess ? CheckCircle : XCircle;
  const iconColor = isSuccess ? 'text-green-600' : 'text-red-600';

  return (
    <div className={`mt-4 p-4 rounded-lg ${bgColor}`}>
      <div className="flex items-start gap-3">
        <IconComponent className={`w-5 h-5 ${iconColor} flex-shrink-0 mt-0.5`} />
        <div className="flex-1">
          {isSuccess ? (
            <SuccessContent result={result} type={type} />
          ) : (
            <ErrorContent result={result} />
          )}
        </div>
      </div>
    </div>
  );
};

const SuccessContent = ({ result, type }) => {
  const { message } = result;
  
  return (
    <div className="text-sm text-green-700 space-y-1">
      <p className="font-semibold">{message}</p>
      
      {type === 'seed' && (
        <>
          <p>• Total tutors: <strong>{result.total_tutors || 0}</strong></p>
          <p>• Public tutors: <strong>{result.public_tutors || 0}</strong></p>
        </>
      )}
      
      {type === 'migration' && (
        <>
          <p>• Modified: <strong>{result.modified_count || 0}</strong> tutors</p>
          {result.details && <p className="text-xs mt-2">{result.details}</p>}
        </>
      )}
      
      {type === 'status' && (
        <>
          <p>• Total Tutors: <strong>{result.total_tutors || 0}</strong></p>
          <p>• Public (Visible): <strong>{result.public_tutors || 0}</strong></p>
          <p>• Private (Hidden): <strong>{result.private_tutors || 0}</strong></p>
          <p>• Active Students: <strong>{result.active_students || 0}</strong></p>
        </>
      )}
    </div>
  );
};

const ErrorContent = ({ result }) => (
  <div className="text-sm text-red-700 space-y-2">
    <p className="font-semibold">Operation Failed</p>
    <p>{result.error || result.message || 'Unknown error occurred'}</p>
    {result.backendUrl && (
      <p className="text-xs opacity-75">Backend: {result.backendUrl}</p>
    )}
  </div>
);

export default ResultCard;
